<template>

  <v-container grid-list-md fluid align-baseline pa-0>

  <v-layout row wrap>

        <v-layout row>                               
        <v-flex xs12 pt-3>
            <div class="font-weight-medium title pa-3">Chapter Photo Gallery</div>            
            <v-card class="radius-card">
                <v-card-title>
                    <v-btn
                    color="accent"
                    dark
                    absolute
                    top
                    right
                    fab
                    @click="viewMyPhotos"
                    >
                    <v-icon>add</v-icon>
                    </v-btn>                         
                </v-card-title>
                <v-card-text>
            <template  v-if="photogallery && photogallery.length>0">
            <div>
                
                <gallery  v-if="photogallery && photogallery.length>0" :images="photogallery.map(i=>{return i.fileurl})" :index="index" @close="index = null"></gallery>
                <v-avatar
                    v-if="photogallery && photogallery.length>0"
                    :tile=true
                    size="80"
                    v-for="(image, imageIndex) in photogallery.map(i=>{return i.fileurl})"
                    :key="imageIndex"
                    @click="index = imageIndex"
                >
                    <img :src="image">
                </v-avatar>
        
            </div>
            </template>  
                </v-card-text>
            </v-card>                  
        </v-flex>                    
        </v-layout>    

            <v-layout row wrap>
                <v-flex xs12 pa-0>
                <v-dialog v-model="panelPhoto"
                fullscreen
                pa-0
                :hide-overlay=false
                
                >

                <v-layout>
                <v-flex xs12>
                    <v-toolbar dark color="primary">
                        <v-toolbar-side-icon @click="closeMyPhotos">
                        <v-icon>close</v-icon>
                                                        
                        </v-toolbar-side-icon>
                        <v-toolbar-title>Manage My Photos</v-toolbar-title>

                    </v-toolbar>                           
                <v-card raised pa-2
                    height="820"
                >
                    
                    <v-card-title>
                        <v-layout row>  
                        <v-flex xs12>
                            <div>
                                <!--
                                <v-subheader class="primary--text "><v-icon class="pr-1" color="primary">add_a_photo</v-icon>Upload an image</v-subheader>
                                <input type="file" accept="image/*" @change="detectFiles($event.target.files)">
                                <v-progress-linear
                                v-if="progressUpload>0"
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>   
                                -->
                                <v-subheader @click="openFileDialog()" class="primary--text font-weight-bold caption"><v-icon large color="primary">add_a_photo</v-icon>Upload a Photo</v-subheader>
                                <input ref="fileinput" style="position:absolute;top:-200px;" type="file" accept="image/*" @change="detectFiles($event.target.files)">

                                <img ref="image_preview" style="position:absolute;top:-900px;" src=""/>
                                <v-progress-linear
                                v-if="progressUpload>0"
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>                                  
                            </div>   
                        </v-flex>  
                        </v-layout>                      
                    </v-card-title>

                    <v-card-text>


                        
                        <v-flex xs12 pt-0>
                            <v-card class="pl-2 pr-2" v-if="currPhoto">

                                <v-card-title>
                                    <v-subheader class="font-weight-bold">Edit:</v-subheader>
                                <v-text-field
                                    v-model="currPhoto.caption"
                                    placeholder="update the caption text"
                                    v-on:change="updatePhotoCaption"
                                ></v-text-field>                                    
                                </v-card-title>
                                <v-card-text>
                            <template  v-if="currPhoto">       
                                <v-layout   >                         
                            <v-flex xs12 >
                                <v-avatar
                                    v-if="currPhoto"
                                    :tile=true
                                    size="200"

                                >
                                    <img :src="currPhoto.fileurl">
                                </v-avatar>
                                <v-subheader  @click="removePhoto(currPhoto)"  class="red--text">  <v-icon color="red">delete_forever</v-icon>Delete Pic</v-subheader>
                            </v-flex>

                             </v-layout>
                            </template>  
                                </v-card-text>

                            </v-card>                  
                        </v-flex>   
                       


                        <v-flex xs12 pt-3>
                            <v-card class="pl-2 pr-2">
                                <v-card-title>
                                    <v-subheader class="font-weight-bold pa-0">Review my uploaded pics</v-subheader>
                                </v-card-title>
                                <v-card-text>
                            <template  v-if="myphotos && myphotos.length>0">                                
                            <v-flex xs12 >
                                <v-avatar
                                    v-if="myphotos && myphotos.length>0"
                                    :tile=true
                                    size="80"
                                    v-for="(image, imageIndex) in myphotos"
                                    :key="imageIndex"
                                    @click="currPhoto = image"
                                >
                                    <img :src="image.fileurl">
                                </v-avatar>
                            </v-flex>

                            </template>  
                                </v-card-text>
                            </v-card>                  
                        </v-flex>                    

                    </v-card-text>
                    <v-card-actions>

                    <br/><br/>
                    </v-card-actions>
                </v-card>

                <v-snackbar
                    v-if="snackbar"
                    v-model="snackbar"
                >
                    {{snackbarText}}
                    <v-btn
                        color="primary"
                        flat
                        @click="closeSnackBar"
                    >
                        Close
                    </v-btn>                            
                </v-snackbar>
                
                                
                </v-flex>
                </v-layout>
                </v-dialog>
                </v-flex>

            </v-layout>
  </v-layout>
  </v-container>
</template>

<script>
import VueGallery from 'vue-gallery'
import firebase from 'firebase'


  export default {
    data () {
        return {   
            progressUpload: 0,
            file: File,
            fileIsImage: false,
            filename: null,
            filetype: null,
            filepath: null,
            uploadTask: '',            
            
            index: null,

            panel: false,
            panelPhoto: false,
            currPhoto: null,

            snackbar: false,
            snackbarText: null,

            

           
        }
    },
    components: {
        'gallery': VueGallery
    },    
    created () {

        //TODO: variablize the entire page to be used for all post types based this.$route.path
        //console.log('.............route.name = ' , this.$route)
        //this.$store.dispatch('loadSortedLinesAndMembers', {chapter: 'zz'})

   
    },
    computed: {
      myColor () {
         return this.$store.getters.myColor
      },         
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      photogallery () {
          return this.$store.getters.photogallery
      },
      myphotos () {
          return this.$store.getters.photogallery.filter(p=>{return p.picid.split('.')[0]===this.$store.getters.member.userid})
      },           
    },
    
    watch: {
        panelPhoto: function (value){
            if(value===false){
                this.currPhoto = null
            }
        },
        uploadTask: function(value) {
            //console.log('inside uploadTask')
            value.on('state_changed', sp => {
                this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
            }, 
            null, 
            () => {
                value.snapshot.ref.getDownloadURL().then(downloadURL => {
                    //console.log('downloadURL', downloadURL)
                    this.$emit('url', downloadURL)

                    this.$store.dispatch('addFileToUploadHistory', {type: 'gallery', fileurl: downloadURL, filepath: this.filepath, member: this.member }).then(errmsg => {
                        //console.log('msg', errmsg)
                        if(errmsg && errmsg ==='failure'){
                            console.error('gallery addFileToUploadHistory', errmsg) 
                        }else{
                            //console.log('successfully added file addFileToUploadHistory') 

                            if(this.fileIsImage){
                                this.$store.dispatch('addFileToGallery', {member: this.member, fileurl: downloadURL, filename: this.filename , filetype: this.filetype, isImage: this.fileIsImage, filepath: this.filepath}).then(errmsg => { //testing the gallery code                                    
                                    //console.log('msg', errmsg)
                                    if(errmsg && errmsg ==='failure'){
                                        console.error('addFileToGallery', errmsg) 
                                    }else{
                                        //console.log('successfully added file to post') 
                                        
                                    }
                                })                                   
                            } 
                            this.fileIsImage = false
                            this.filename = null
                            this.filetype = null
                            this.filepath = null

                        }
                    })                      

                })
            })
        }        
    },
    methods: {
        openFileDialog: function (){
            var inputbutton = this.$refs.fileinput
            //console.log('inputbutton',inputbutton)
            inputbutton.click()

        },               
        openSnackBar: function (){
            this.snackbar = true
        },
        closeSnackBar: function (){
            this.snackbar = false
            this.snackbarText = null
        },
        viewMyPhotos: function () {
          this.panelPhoto = true

        },        
        closeMyPhotos: function(){
            this.panelPhoto = false
        },
        removePhoto: function(p){
            //TODO call remove
            p.active=false
            var payload = new Object()
            payload.member = this.member
            payload.picupdates = p
            this.$store.dispatch('updateFileFromGallery', payload).then(errmsg => { //testing the gallery code                                    
                //console.log('msg', errmsg)
                if(errmsg && errmsg ==='failure'){
                    console.error('error removing photo', errmsg) 
                    this.snackbarText = "Error deleting pic"
                    this.openSnackBar()
                }else{
                    //console.log('successfully removed photo file to post') 
                    this.currPhoto = null
                    this.snackbarText = "Pic deleted successfully"
                    this.openSnackBar()
                    
                }
            })               

        },  
        updatePhotoCaption(){
            var payload = new Object()
            payload.member = this.member
            var picUpdates = new Object()
            picUpdates.picid = this.currPhoto.picid
            picUpdates.caption = this.currPhoto.caption
            payload.picupdates = picUpdates
            this.$store.dispatch('updateFileFromGallery', payload).then(errmsg => { //testing the gallery code                                    
                //console.log('msg', errmsg)
                if(errmsg && errmsg ==='failure'){
                    console.error('error updating photo', errmsg) 
                    this.snackbarText = "Error updating pic"
                    this.openSnackBar()
                }else{
                    //console.log('successfully updated photo file to post') 
                    this.currPhoto = null
                    this.snackbarText = "Pic updated successfully"
                    this.openSnackBar()
                    
                }
            }) 
        },      
        detectFiles: function (fileList) {
        Array.from(Array(fileList.length).keys()).map( x => {
            this.upload(fileList[x])
        })
        },        
        upload: function (file) {
            if(file.type.indexOf('image')>-1){
                this.fileIsImage = true
                var dataUrl = "";
                // Create an image
                var img = document.createElement("img");
                img.addEventListener('load', ()=> {
                // execute drawImage statements here
                   var canvas = document.createElement("canvas");
                    //var canvas = $("<canvas>", {"id":"testing"})[0];
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);            
                    // Set Width and Height
                    var MAX_WIDTH = 400;
                    var MAX_HEIGHT = 300;
                    var width = img.width;
                    var height = img.height;            
                    if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                    } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, height);            
                    //console.log('calling canvas',canvas)
                    dataUrl = canvas.toDataURL(file.type);                    
                    this.$refs.image_preview.src = dataUrl;    
                    //console.log('calling dataUrl', dataUrl)
                    this.filename = new Date().getTime() + '_' + file.name
                    this.filetype = file.type
                    this.filepath = this.member.org + '_' + this.member.chapter + '/gallery/' +  this.filename

                    this.uploadTask = firebase.storage().ref(this.filepath).putString(dataUrl, 'data_url')
                }, false);            
                // Create a file reader
                var reader = new FileReader();
                // Set the image once loaded into file reader
                reader.onload = (e)=>
                {
                    //console.log('calling reader.onload  e', e)

                    img.src = e.target.result;
                    //console.log('calling reader.onload  img', img)                   
                }
                // Load files into file reader
                reader.readAsDataURL(file);               

            }
        }           
                      
    }
  }
</script>

<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.radius-card{
  border-radius:15px;
 
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}
.loc-card{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-me{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-date{
    text-align: right;
    margin-right:15px;
    color:dimgrey;
}
</style>